import customCallbackHandler from '../shared/customCallbackHandler';
const touchEnd = customCallbackHandler.bind(null, 'Touch', 'touchEndCallback');
export default touchEnd;
//# sourceMappingURL=touchEnd.js.map